import React from 'react'
import { messageTypes } from '../../../../actions/messages'
import {
  Form, Select, Input, Button, Divider, InputNumber
} from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { groupsBlacklisted } from '../maps/mapDraw'

const { Option } = Select

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}

class StyledChallengeCategoryForm extends React.Component {
  formRef = React.createRef()

  handleSubmit = (values) => {
    const { data, isNewRecord, addRecord, updateRecord } = this.props
    const obj = {}
    obj.name = {}
    obj.name.pl = values.name_pl
    obj.name.en = values.name_en
    obj.rorder = values.rorder
    obj.stack_type = values.stack_type
    obj.icon = values.icon

    if (isNewRecord) { addRecord(obj) } else { updateRecord(data._id, obj) }
  }

  setDefaultValues = () => {
    const { data, isNewRecord } = this.props

    if (data && Object.keys(data).length > 0 && !isNewRecord) {
      this.setState({}, () => {
        const fieldsVal = {
          name_pl: data.name.pl,
          name_en: data.name.en,
          rorder: data.rorder,
          stack_type: data.stack_type,
          icon: data.icon
        }
        this.formRef.current.setFieldsValue(fieldsVal)
      })
    } else {
      this.setState({
      }, () => {
        this.formRef.current.setFieldsValue({
          name_pl: '',
          name_en: '',
          rorder: 0,
          stack_type: undefined,
          icon: ''
        })
      })
    }
  }

  componentDidMount () {
    this.setDefaultValues()
  }

  componentDidUpdate (prevProps, prevState) {
    const { data, isNewRecord } = this.props

    if (data._id !== prevProps.data._id || isNewRecord !== prevProps.isNewRecord) {
      this.setDefaultValues()
    }
  }

  render () {
    const { language, loading } = this.props

    return (
      <Form onFinish={this.handleSubmit} layout='horizontal' ref={this.formRef}>

        <Form.Item
          name='name_pl'
          label={messageTypes[language].name_pl}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...formItemLayout}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name='name_en'
          label={messageTypes[language].name_en}
          // rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...formItemLayout}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name='stack_type'
          label={messageTypes[language].stack_type}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...formItemLayout}
        >
          <Select>
            {
              this.props.overlordStackTypes.length
                ? this.props.overlordStackTypes.map((stackType, n) =>
                  <Option key={n} value={stackType.name}>{stackType.name}</Option>
                )
                : ''
            }
          </Select>
        </Form.Item>

        <Form.Item
          name='icon'
          label={messageTypes[language].map_icon}
          {...formItemLayout}
        >
          <Select allowClear>
            {
              Object.keys(groupsBlacklisted).map((group, n) =>
                <Option key={n} value={group}>
                  {groupsBlacklisted[group]?.image && <><img style={{ height: '22px' }} src={groupsBlacklisted[group]?.image} alt={group} /> </>}
                  {group}
                </Option>)
            }
          </Select>
        </Form.Item>

        <Form.Item
          name='rorder'
          label={messageTypes[language].order}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...formItemLayout}
        >
          <InputNumber />
        </Form.Item>

        <Form.Item className='form-footer'>
          <Divider />
          <Button htmlType='submit'>{loading ? <LoadingOutlined /> : ''} {messageTypes[language].submit}</Button>
          <Button onClick={() => { this.props.onCancel() }} className='cancel'>{messageTypes[language].cancel}</Button>
        </Form.Item>
      </Form>
    )
  }
}

export default StyledChallengeCategoryForm
